import { CreatorIntegrationsApiClient } from '@fourthwall/services/dist/CreatorIntegrationsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useKitConfigurationQuery = createQueryHook(
  CreatorIntegrationsApiClient.getKitConfiguration,
  {
    queryKey: ['kitConfiguration'],
  },
)
